import moment from 'moment';
import Select from "react-select";
import DatePicker from "react-datepicker";
import { allowSave, Option } from "../../../store/helpers";
import "react-datepicker/dist/react-datepicker.css";
import { RootState } from "../../../store/rootReducer";
import { DOWNLOAD_DOCUMENT } from "../../../store/api";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updateJenisDokumen, updatePicUMN, updateStatus, updateTanggalMulai, updateNomorDokumen, updateDeskripsi, updateTanggalSelesai, updateFile, getDokumenKerjasamaAsync, updateNomorInduk, deleteFile, updateJudulDokumen, updateNomorDokumenPt } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { fieldErrorMessage, fieldHasErrors } from '../../../store/errorHandler';
import { PermissionMenuName } from '../../../interfaces/UserRole';

export const FormDetail = () => {
  const dispatch = useDispatch();
  
  const errors = useSelector((state: RootState) => state.dokumenKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const detailDokumenKerjasama = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  const canSave = allowSave(role, 2);

  // for employee list options
  const listEmployee = useSelector((state: RootState) => state.employee.listEmployee);
  const [employeeOptions, setEmployeeOptions] = useState<Option[]>([]);

  // for document number options
  const listDokumen = useSelector((state: RootState) => state.dokumenKerjasama.listDokumenKerjasama);
  const [dokumenOptions, setDokumenOptions] = useState<Option[]>([]);

  // for document type options
  const listJenisDokumen = useSelector((state: RootState) => state.jenisDokumen.listJenisDokumen);
  const [jenisDokumenOptions, setJenisDokumenOptions] = useState<Option[]>([]);

  // for status options
  const listStatus = useSelector((state: RootState) => state.statusKerjasama.listStatusKerjasama);
  const [statusKerjasamaOptions, setStatusKerjasama] = useState<Option[]>([]);

  // for file upload
  const selectedFile = useSelector((state: RootState) => state.dokumenKerjasama.selectedFile);
  const fileInput = useRef<HTMLInputElement>(null);

  const getSelectedEmployeeOption = () => {
    if (!detailDokumenKerjasama || !detailDokumenKerjasama.EMP_DETAIL) return null;
    const selection = detailDokumenKerjasama.EMP_DETAIL;
    return { value: selection.EMP_ID.toString(), label: selection.EMP_NAME };
  }

  const getSelectedJenisDokumenOption = () => {
    if (!detailDokumenKerjasama || !detailDokumenKerjasama.DOK_JENIS_DETAIL) return null;
    const selection = detailDokumenKerjasama.DOK_JENIS_DETAIL;
    return { value: selection.DOK_JENIS_ID.toString(), label: selection.DOK_JENIS_NAMA };
  }

  const getSelectedStatusOption = () => {
    if (!detailDokumenKerjasama || !detailDokumenKerjasama.STATUS_DETAIL) return null;
    const selection = detailDokumenKerjasama.STATUS_DETAIL;
    return { value: selection.STATUS_ID.toString(), label: selection.STATUS_NAME };
  }

  const getSelectedDokumenOption = () => {
    if (!detailDokumenKerjasama || !detailDokumenKerjasama.DOK_DETAIL) return null;
    const selection = detailDokumenKerjasama.DOK_DETAIL;
    return { value: selection.DOK_ID.toString(), label: selection.DOK_NOMOR };
  }

  const onChangeDokumen = (e: Option | null) => {
    if (!e) return;
    const id = parseInt(e.value);
    if (isNaN(id)) return;
    const newDokumen = listDokumen.find(search => search.DOK_ID === id);
    if (newDokumen) { dispatch(updateNomorInduk(id, newDokumen)); }
  }

  const onChangeJenisDokumen = (e: Option | null) => {
    if (!e) return;
    const id = parseInt(e.value);
    if (isNaN(id)) return;
    const newJenisDokumen = listJenisDokumen.find(search => search.DOK_JENIS_ID === id);
    if (newJenisDokumen) { dispatch(updateJenisDokumen(id, newJenisDokumen)); }
  }

  const onChangePicUmn = (e: Option | null) => {
    if (!e) return;
    const id = e.value;
    const newPicUMN = listEmployee.find(search => search.EMP_ID === id);
    if (newPicUMN) { dispatch(updatePicUMN(e.value, newPicUMN)); }
  }

  const onChangeStatus = (e: Option | null) => {
    if (!e) return;

    const id = parseInt(e.value);
    if (isNaN(id)) return;

    const newStatus = listStatus.find(search => search.STATUS_ID === id);

    if (newStatus) {
      dispatch(updateStatus(id, newStatus));
    }
  }

  const onChangeJudulDokumen = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateJudulDokumen(e.target.value));
  }

  const onChangeNomorDokumen = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateNomorDokumen(e.target.value));
  }

  const onChangeNomorDokumenPt = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateNomorDokumenPt(e.target.value));
  }

  const onChangeDeskripsi = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(updateDeskripsi(e.target.value));
  }

  const onChangeTanggalMulai = (date: Date) => {
    if (!detailDokumenKerjasama) return;
    if (moment(date).diff(detailDokumenKerjasama.PERIODE_AKHIR) > 0) {
      dispatch(showModal('Proses mengganti tanggal gagal', 'Tanggal mulai harus lebih kecil dari tanggal selesai'));
      return;
    }
    dispatch(updateTanggalMulai(moment(date).format('YYYY-MM-DD')));
  }

  const onChangeTanggalSelesai = (date: Date) => {
    if (!detailDokumenKerjasama) return;
    if (moment(date).diff(detailDokumenKerjasama.PERIODE_AWAL) < 0) {
      dispatch(showModal('Proses mengganti tanggal gagal', 'Tanggal selesai harus lebih besar dari tanggal mulai'));
      return;
    }
    dispatch(updateTanggalSelesai(moment(date).format('YYYY-MM-DD')));
  }

  const addDokumen = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      dispatch(updateFile(file));
    }
  }

  const download = (url: string) => {
    window.open(`${DOWNLOAD_DOCUMENT}${url}`, "_blank");
  }

  const clearFileData = () => {
    dispatch(deleteFile());
  }

  const cancelChanges = () => {
    if (fileInput && fileInput.current) {
      fileInput.current.value = "";
    }
    dispatch(updateFile(null));
  }

  useEffect(() => {
    let newOptions: Option[] = [];
    newOptions = listDokumen.map(item => {
      return {
        value: item.DOK_ID.toString(),
        label: item.DOK_NOMOR
      };
    });
    setDokumenOptions(newOptions);
  }, [listDokumen]);
  
  useEffect(() => {
    let newOptions: Option[] = [];
    newOptions = listEmployee.map(item => {
      return {
        value: item.EMP_ID.toString(),
        label: item.EMP_NAME
      }
    });
    setEmployeeOptions(newOptions);
  }, [listEmployee]);

  useEffect(() => {
    let newOptions: Option[] = [];
    newOptions = listJenisDokumen.map(item => {
      return {
        value: item.DOK_JENIS_ID.toString(),
        label: item.DOK_JENIS_NAMA
      };
    });
    setJenisDokumenOptions(newOptions);
  }, [listJenisDokumen]);

  useEffect(() => {
    let newOptions: Option[] = [];
    newOptions = listStatus.map(item => {
      return {
        value: item.STATUS_ID.toString(),
        label: item.STATUS_NAME
      };
    });
    setStatusKerjasama(newOptions);
  }, [listStatus]);

  useEffect(() => {
    if (detailDokumenKerjasama && detailDokumenKerjasama.DOK_JENIS_DETAIL) {
      const detail = detailDokumenKerjasama.DOK_JENIS_DETAIL;
      if (detail.DOK_JENIS_PARENT === null) {
        
      } else {
        dispatch(getDokumenKerjasamaAsync.request({ jenis_dokumen: detail.DOK_JENIS_PARENT }));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailDokumenKerjasama?.DOK_JENIS_ID]);

  if (!detailDokumenKerjasama) return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Detail Kerjasama</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Detail Kerjasama</h3>
          <div className="box-tools pull-right"></div>
        </div>
        <div className="box-body">
          <div className={`form-group ${fieldHasErrors('DOK_JUDUL_KERJASAMA', errors) ? 'has-error' : ''}`}>
            <label>Judul Dokumen <span className="text-red"><b>*</b></span></label>
            <input
              type="text"
              className="form-control"
              disabled={isLoading || !canSave}
              value={detailDokumenKerjasama.DOK_JUDUL_KERJASAMA}
              onChange={onChangeJudulDokumen}
            />
            <span className="help-block">{ fieldErrorMessage('DOK_JUDUL_KERJASAMA', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_JENIS_ID', errors) ? 'has-error' : ''}`}>
            <label>Jenis Dokumen Kerjasama <span className="text-red"><b>*</b></span></label>
            <Select
              isDisabled={isLoading || !canSave}
              options={jenisDokumenOptions}
              value={getSelectedJenisDokumenOption()}
              onChange={onChangeJenisDokumen}
            />
            <span className="help-block">{ fieldErrorMessage('DOK_JENIS_ID', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_PARENT_ID', errors) ? 'has-error' : ''}`}>
            <label>Nomor Dokumen Induk</label>
            { detailDokumenKerjasama.DOK_JENIS_DETAIL?.DOK_JENIS_PARENT ? 
              <Select
                isDisabled={isLoading || !canSave}
                options={dokumenOptions}
                value={getSelectedDokumenOption()}
                onChange={onChangeDokumen}
              /> :
              <input
                type="text"
                disabled={true}
                className="form-control"
                value={"Tidak perlu nomor induk"}
              />
            }
            <span className="help-block">{ fieldErrorMessage('DOK_PARENT_ID', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_NOMOR_PT', errors) ? 'has-error' : ''}`}>
            <label>Nomor Dokumen Perguruan Tinggi</label>
            <input
              type="text"
              disabled={isLoading || !canSave}
              className="form-control"
              onChange={onChangeNomorDokumenPt}
              value={detailDokumenKerjasama.DOK_NOMOR_PT}
            />
            <span className="help-block">{ fieldErrorMessage('DOK_NOMOR_PT', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_NOMOR', errors) ? 'has-error' : ''}`}>
            <label>Nomor Dokumen <span className="text-red"><b>*</b></span></label>
            <input
              type="text"
              className="form-control"
              disabled={isLoading || !canSave}
              value={detailDokumenKerjasama.DOK_NOMOR}
              onChange={onChangeNomorDokumen}
            />
            <span className="help-block">{ fieldErrorMessage('DOK_NOMOR', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_DESCR', errors) ? 'has-error' : ''}`}>
            <label>Deskripsi Singkat Kerjasama <span className="text-red"><b>*</b></span></label>
            <textarea
              className="form-control"
              placeholder="Masukan deskripsi singkat"
              onChange={onChangeDeskripsi}
              disabled={isLoading || !canSave}
              value={detailDokumenKerjasama.DOK_DESCR}
            />
            <span className="help-block">{ fieldErrorMessage('DOK_DESCR', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('EMP_ID', errors) ? 'has-error' : ''}`}>
            <label>Nama PIC UMN</label>
            <Select
              isDisabled={isLoading || !canSave}
              options={employeeOptions}
              value={getSelectedEmployeeOption()}
              onChange={onChangePicUmn}
            />
            <span className="help-block">{ fieldErrorMessage('EMP_ID', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('PERIODE_AWAL', errors) ? 'has-error' : ''}`}>
            <label>Tanggal Mulai</label>
            <DatePicker
              disabled={isLoading || !canSave}
              className="form-control"
              selected={moment(detailDokumenKerjasama.PERIODE_AWAL).toDate()}
              onChange={onChangeTanggalMulai}
            />
            <span className="help-block">{ fieldErrorMessage('PERIODE_AWAL', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('PERIODE_AKHIR', errors) ? 'has-error' : ''}`}>
            <label>Tanggal Selesai</label>
            <DatePicker
              disabled={isLoading || !canSave}
              className="form-control"
              onChange={onChangeTanggalSelesai}
              selected={moment(detailDokumenKerjasama.PERIODE_AKHIR).toDate()}
            />
            <span className="help-block">{ fieldErrorMessage('PERIODE_AKHIR', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('STATUS_ID', errors) ? 'has-error' : ''}`}>
            <label>Status <span className="text-red"><b>*</b></span></label>
            <Select
              isDisabled={isLoading || !canSave}
              options={statusKerjasamaOptions}
              value={getSelectedStatusOption()}
              onChange={onChangeStatus}
            />
            <span className="help-block">{ fieldErrorMessage('STATUS_ID', errors) }</span>
          </div>
          <div className={`form-group ${fieldHasErrors('DOK_FILE', errors) ? 'has-error' : ''}`}>
            <label>Dokumen</label><br/>
            { detailDokumenKerjasama.DOK_FILE_NAME ? null : (
              <input
                ref={fileInput}
                type="file"
                disabled={isLoading || !canSave}
                onChange={addDokumen}
                className="form-control"
                accept=".pdf"
                placeholder="Unggah dokumen kerjasama (pdf)"
              />
            ) }
            <div style={{ marginTop: '5px' }}>
              { detailDokumenKerjasama.DOK_FILE_NAME ? (
                  <React.Fragment>
                    <button type="button" className="btn btn-primary" disabled={isLoading} onClick={() => download(detailDokumenKerjasama.DOK_FILE_NAME)}>
                      Unduh Berkas
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-danger" disabled={isLoading || !canSave} onClick={() => clearFileData()}>
                      Hapus Berkas
                    </button>
                  </React.Fragment>
                ) : null
              }

              {
                selectedFile ? (
                  <React.Fragment>
                    &nbsp;
                    <button type="button" className="btn btn-danger" disabled={isLoading || !canSave} onClick={() => cancelChanges()}>
                      Batalkan Perubahan
                    </button>
                  </React.Fragment>
                ) : null
              }
            </div>
            <span className="help-block">{ fieldErrorMessage('DOK_FILE', errors) }</span>
          </div>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
